/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Guess_Placeholder_CapitalInputs */

const bn_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অটোয়া, টোকিও, ব্রাসিলিয়া...`)
};

const de_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tokio, Brasilien...`)
};

const el_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οττάβα, Τόκιο, Μπραζίλια...`)
};

const en_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tokyo, Brasilia...`)
};

const es_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tokio, Brasilia...`)
};

const fr_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tokyo, Brasilia...`)
};

const hi_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओटावा, टोक्यो, ब्रासीलिया...`)
};

const hu_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tokió, Brazília...`)
};

const id_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tokyo, Brasilia...`)
};

const it_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tokio, Brasilia...`)
};

const ja_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オタワ、東京、ブラジリア…。`)
};

const ko_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오타와, 도쿄, 브라질리아...`)
};

const nl_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tokio, Brazilië...`)
};

const pl_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tokio, Brazylia...`)
};

const pt_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tóquio, Brasília...`)
};

const ru_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оттава, Токио, Бразилиа...`)
};

const sv_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tokyo, Brasilia...`)
};

const tr_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tokyo, Brezilya...`)
};

const uk_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оттава, Токіо, Бразиліа...`)
};

const vi_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottawa, Tokyo, Brasilia...`)
};

const zh_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渥太华、东京、巴西利亚...`)
};

const zh_hant_game_guess_placeholder_capital = /** @type {(inputs: Game_Guess_Placeholder_CapitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渥太華、東京、巴西利亞...`)
};

/**
* | output |
* | --- |
* | "Ottawa, Tokyo, Brasilia..." |
*
* @param {Game_Guess_Placeholder_CapitalInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_guess_placeholder_capital = /** @type {((inputs?: Game_Guess_Placeholder_CapitalInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Guess_Placeholder_CapitalInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_guess_placeholder_capital(inputs)
	if (locale === "de") return de_game_guess_placeholder_capital(inputs)
	if (locale === "el") return el_game_guess_placeholder_capital(inputs)
	if (locale === "en") return en_game_guess_placeholder_capital(inputs)
	if (locale === "es") return es_game_guess_placeholder_capital(inputs)
	if (locale === "fr") return fr_game_guess_placeholder_capital(inputs)
	if (locale === "hi") return hi_game_guess_placeholder_capital(inputs)
	if (locale === "hu") return hu_game_guess_placeholder_capital(inputs)
	if (locale === "id") return id_game_guess_placeholder_capital(inputs)
	if (locale === "it") return it_game_guess_placeholder_capital(inputs)
	if (locale === "ja") return ja_game_guess_placeholder_capital(inputs)
	if (locale === "ko") return ko_game_guess_placeholder_capital(inputs)
	if (locale === "nl") return nl_game_guess_placeholder_capital(inputs)
	if (locale === "pl") return pl_game_guess_placeholder_capital(inputs)
	if (locale === "pt") return pt_game_guess_placeholder_capital(inputs)
	if (locale === "ru") return ru_game_guess_placeholder_capital(inputs)
	if (locale === "sv") return sv_game_guess_placeholder_capital(inputs)
	if (locale === "tr") return tr_game_guess_placeholder_capital(inputs)
	if (locale === "uk") return uk_game_guess_placeholder_capital(inputs)
	if (locale === "vi") return vi_game_guess_placeholder_capital(inputs)
	if (locale === "zh") return zh_game_guess_placeholder_capital(inputs)
	return zh_hant_game_guess_placeholder_capital(inputs)
});